import styled from "styled-components";

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.COLORS.Light};
  color: ${({ theme }) => theme.COLORS.DarkMed};
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
